import React from "react"

import { AwardRankingBannerWrapper } from "../../styles"
import AwardsIntroBanner from "./AwardsIntroBanner"
import BannerActionsContainer from "./BannerActionsContainer"

const AwardRankingBanner = () => {
  return (
    <AwardRankingBannerWrapper>
      <AwardsIntroBanner />
      <BannerActionsContainer />
    </AwardRankingBannerWrapper>
  )
}

export default AwardRankingBanner
